import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f96bf96"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "qualification" }
const _hoisted_2 = { class: "qualification_txt" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "qualification_txt_set" }, [
  /*#__PURE__*/_createTextVNode(" 根据国家《网络主播行为规范》相关规定，对于需要较高专业水平(如 "),
  /*#__PURE__*/_createElementVNode("span", null, "医疗卫生、财经金融、法律、教育"),
  /*#__PURE__*/_createTextVNode(")的直播内容，主播应取得相应职业资质，并向直播平台进行执业资质报备。 ")
], -1))
const _hoisted_4 = { class: "qualification_content" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "qualification_set_name" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "qualification_set_name_must" }, "*"),
  /*#__PURE__*/_createTextVNode(" 直播参与者姓名： ")
], -1))
const _hoisted_6 = { class: "qualification_content" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "qualification_set_name" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "qualification_set_name_must" }, "*"),
  /*#__PURE__*/_createTextVNode(" 执业资质类型： ")
], -1))
const _hoisted_8 = { class: "qualification_content" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "qualification_set_name" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "qualification_set_name_must" }, "*"),
  /*#__PURE__*/_createTextVNode(" 执业资质上传： ")
], -1))
const _hoisted_10 = { class: "qualification_set_right" }
const _hoisted_11 = { class: "qualification_set_upload" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "qualification_set_btn_p" }, " 上传原件或复印件，复印件务必加盖公司公章，文件适合jpg、jpeg、 或png，文件大小不超过2M。 ", -1))
const _hoisted_13 = {
  key: 0,
  class: "qualification_set_nav"
}
const _hoisted_14 = { class: "qualification_set_img" }
const _hoisted_15 = { class: "nav" }
const _hoisted_16 = { class: "nav" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "qualification_btn" }

import {
  InfoCircleFilled,
  UploadOutlined,
  FileTextOutlined,
  CheckCircleOutlined,
  LoadingOutlined,
  CloseOutlined,
  PlusCircleOutlined,
  MinusCircleOutlined,
} from '@ant-design/icons-vue';
import { ref, unref, watch, computed } from 'vue';
import { message, Upload, Switch, Image } from 'ant-design-vue';
import { getToken } from '@/plugins/cookie';
import { ListType, ObjType } from './type';
import { useLiveStore } from '@/pinia/live';
import { useDebounce } from '@/hooks/useDebounce';

interface FileItem {
  uid: string;
  name?: string;
  status?: string;
  response?: any;
  url?: string;
  type?: string;
  size: number;
  originFileObj: any;
}
interface FileInfo {
  file: FileItem;
  fileList: FileItem[];
}

interface IProps {
  modelValue: ObjType;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Qualifications',
  props: {
    modelValue: null
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit }) {

const props = __props as {
  modelValue: ObjType;
};

const liveStore = useLiveStore();
const liveInfo = computed(() => liveStore.liveInfo);
const aUpload = Upload;
const aSwitch = Switch;
const aImage = Image;
const token = getToken();
const qualifications = ref<ObjType>({
  status: false,
  list: [{ useName: '', useType: '', fileList: [], imgageUrl: '', loading: false, imgageName: '', imgageSize: 0 }],
});
const form = ref<ListType[]>([]);


qualifications.value = unref(props.modelValue);
form.value = qualifications.value.list;

watch(qualifications.value, (newVal) => {
  emit('update:modelValue', newVal);
});

const increaseList = useDebounce(() => {
  form.value.push({
    useName: '',
    useType: '',
    fileList: [],
    imgageUrl: '',
    loading: false,
    imgageName: '',
    imgageSize: 0,
  });
});

const reduceList = useDebounce(() => {
  form.value.splice(form.value.length - 1, 1);
});

const beforeUpload = (file: FileItem, item: ListType) => {
  if (file.name) {
    item.imgageName = file.name;
    item.imgageSize = file.size;
  }
  const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg';
  if (!isJpgOrPng) {
    message.error('上传图片的格式有误!');
    item.imgageName = '';
  }
  const isLt2M = file.size / 1024 / 1024 < 2;
  if (!isLt2M) {
    message.error('上传图片的大小不能超过2M!');
    item.imgageName = '';
    item.imgageUrl = '';
  }
  return isJpgOrPng && isLt2M;
};
const handleChange = (info: FileInfo, item: ListType) => {
  if (info.file?.response?.code === 200) {
    item.imgageUrl = info.file?.response?.data.url;
    message.success('上传成功');
  }
  if (info.file.status === 'uploading') {
    item.loading = true;
    return;
  } else item.loading = false;
  if (info.file?.response?.code === 100) {
    item.loading = false;
    message.error(info.file?.response?.error);
  }
};
const clickClear = (item: ListType) => {
  item.imgageUrl = '';
  item.imgageName = '';
  item.imgageSize = 0;
};

const widthRef = ref<HTMLDivElement>();

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createVNode(_unref(InfoCircleFilled))
      ]),
      _hoisted_3
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.value, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "qualification_set",
        key: index
      }, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_a_input, {
            value: item.useName,
            "onUpdate:value": ($event: any) => ((item.useName) = $event),
            placeholder: "请填写参与者姓名"
          }, null, 8, ["value", "onUpdate:value"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(_component_a_input, {
            value: item.useType,
            "onUpdate:value": ($event: any) => ((item.useType) = $event),
            placeholder: "请填写资质类型"
          }, null, 8, ["value", "onUpdate:value"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_unref(aUpload), {
                "file-list": item.fileList,
                "onUpdate:fileList": ($event: any) => ((item.fileList) = $event),
                name: "images",
                showUploadList: false,
                "before-upload": (file) => beforeUpload(file, item),
                onChange: (info) => handleChange(info, item),
                accept: ".jpg,.jpeg,.png",
                action: "/api/v1/common/upload_images",
                headers: { token: _unref(token) }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, { class: "qualification_set_btn" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(UploadOutlined)),
                      _createTextVNode(" 上传文件 ")
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, 1032, ["file-list", "onUpdate:fileList", "before-upload", "onChange", "headers"]),
              _hoisted_12
            ]),
            (item.imgageName)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_unref(FileTextOutlined)),
                    _createTextVNode("  "),
                    _createElementVNode("span", _hoisted_15, _toDisplayString(item.imgageName), 1),
                    _createElementVNode("span", _hoisted_16, _toDisplayString((item.imgageSize / 1024 / 1024).toFixed(4)) + "MB", 1),
                    (item.loading)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                          _createVNode(_unref(LoadingOutlined))
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_18, [
                          _createVNode(_unref(CheckCircleOutlined), { class: "qualification_set_img_icon1" }),
                          _createVNode(_unref(CloseOutlined), {
                            class: "qualification_set_img_icon2",
                            onClick: ($event: any) => (clickClear(item))
                          }, null, 8, ["onClick"])
                        ]))
                  ]),
                  _createVNode(_unref(aImage), {
                    width: "70%",
                    src: item.imgageUrl
                  }, null, 8, ["src"])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]))
    }), 128)),
    _createElementVNode("div", _hoisted_19, [
      _withDirectives(_createVNode(_component_a_button, {
        class: "nav",
        onClick: _unref(reduceList)
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(MinusCircleOutlined)),
          _createTextVNode("删除备案")
        ]),
        _: 1
      }, 8, ["onClick"]), [
        [_vShow, form.value.length > 1]
      ]),
      _createVNode(_component_a_button, {
        class: "qualification_btn_add",
        onClick: _unref(increaseList)
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(PlusCircleOutlined)),
          _createTextVNode("添加备案")
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}
}

})